<template>
  <div class="ai-detail-talk">
    <div class="tab-box__left-body">
      <template v-for="(talk, index) in chatList" :key="index">
        <div class="talk-item" :class="`talk-item-${String(talk.start).replace(/\./g, '_')}`">
          <div class="talk-item-avatar">
            <div
              class="avatar"
              :style="{
                backgroundColor: getAvatar(talk.speakUser).color
              }"
            >
              {{ getAvatar(talk.speakUser).name }}
            </div>
            <div class="talk-item-avatar-right">
              <div class="name">{{ talk.speakUser }}</div>
              <div class="time" @click="openTalk(talk.start)">{{ formatTime(talk.start) }}</div>
            </div>
          </div>
          <div class="talk-item-content" @click="openTalk(talk.start)">
            <div class="talk-item-content-text" :class="{ 'is-risk': talk.riskStatus === 1 }">
              {{ talk.text }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { getAvatar } from '@/utils/ai-talk'

const emits = defineEmits(['startWithTime'])

defineProps({
  chatList: {
    type: Array,
    default: () => []
  }
})

const formatTime = (seconds) => {
  const totalSeconds = Math.floor(seconds)
  const h = Math.floor(totalSeconds / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)
  const s = totalSeconds % 60

  return [
    h.toString().padStart(2, '0'),
    m.toString().padStart(2, '0'),
    s.toString().padStart(2, '0')
  ].join(':')
}

const openTalk = (time) => {
  emits('startWithTime', time)
}

const handleScrollToTime = (time) => {
  const selector = `.talk-item-${String(time).replace(/\./g, '_')}` // 时间点可能包含小数点，需要替换为下划线
  const element = document.querySelector(selector)
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })
    // 边框闪烁动画
    const content = element.querySelector('.talk-item-content')
    if (content) {
      content.classList.remove('border-flash') // 先移除，防止连续点击无效
      // 触发重绘
      void content.offsetWidth
      content.classList.add('border-flash')
      setTimeout(() => {
        content.classList.remove('border-flash')
      }, 3000) // 动画持续时间和css一致
    }
  }
}

defineExpose({
  handleScrollToTime
})
</script>

<style lang="scss" scoped>
.ai-detail-talk {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  .tab-box__left-body {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .talk-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;
      .talk-item-avatar {
        margin-right: 12px;
        display: flex;
        align-items: center;
        .avatar {
          width: 24px;
          height: 24px;
          border-radius: 8px;
          margin-right: 8px;
          color: #ffffff;
          font-size: 12px;
          font-weight: 600;
          text-align: center;
          line-height: 24px;
        }
        .talk-item-avatar-right {
          display: flex;
          .name {
            color: #646566;
            margin-right: 8px;
          }
          .time {
            color: #969799;
            cursor: pointer;
            &:hover {
              color: #323233;
            }
          }
        }
      }
      .talk-item-content {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        line-height: 20px;
        margin-top: 8px;
        padding: 12px;
        background: #ffffff;
        border-radius: 12px;
        box-sizing: border-box;
        width: max-content;
        max-width: 100%;
        position: relative;
        border: 1px solid #ffffff;
        transition: border-color 0.2s;
        cursor: pointer;
        &:hover {
          border: 1px solid #7a52f4;
        }
      }
      .border-flash {
        animation: border-flash-anim 0.8s 3;
      }
      @keyframes border-flash-anim {
        0% {
          border-color: #7a52f4;
        }
        100% {
          border-color: #ffffff;
        }
      }
      .talk-item-content-text {
        font-family: PingFang SC;
        color: #323233;
        width: max-content;
        max-width: 100%;
      }
      .is-risk {
        background: #ffece8;
      }
    }
  }
}

.ai-detail-talk--mobile {
  padding: 0 !important;
}
</style>
